import React from 'react';
import Leads_Comp from '../../Components/Leads/Leads';
import Dashboard_Comp from '../../Components/Dashboard/Dashboard';

function Leads() {
  return (
    <Dashboard_Comp>
    <Leads_Comp />
    </Dashboard_Comp>
  )
}

export default Leads;